import { injectable } from 'inversify';
import { NinthAgeUnitV2MakeParams } from '@Components/survey/NinthAgeUnitV2Make/NinthAgeUnitV2MakeValidate';
import { Result } from '@Redux/type';
import { AnswerEntry, AnswerEntryType } from '@Models';

@injectable()
export class SurveyAction {
  public saveUnit =
    (values: NinthAgeUnitV2MakeParams): Result<void> =>
    async (dispatch, getState) => {};

  public convertToParams = (
    values: NinthAgeUnitV2MakeParams,
  ): AnswerEntry[] => {
    return [
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'points',
        value: values.points,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'addPoints',
        value: values.addPoints,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'sizeMin',
        value: values.sizeMin,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'sizeMax',
        value: values.sizeMax,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.adv',
        value: values.carac.adv,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.mar',
        value: values.carac.mar,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.dis',
        value: values.carac.dis,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.evoked',
        value: values.carac.evoked ?? '',
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.hp',
        value: values.carac.hp,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.def',
        value: values.carac.def,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.res',
        value: values.carac.res,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.arm',
        value: values.carac.arm,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.aeg',
        value: values.carac.aeg,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.fly.adv',
        value: values.carac.fly.adv,
      } satisfies AnswerEntry as AnswerEntry,
      {
        entryId: 1,
        entryType: AnswerEntryType.Unit,
        key: 'carac.fly.mar',
        value: values.carac.fly.mar,
      } satisfies AnswerEntry as AnswerEntry,

      ...values.troops.flatMap((troop) => {
        return [
          {
            entryId: troop.id,
            entryType: AnswerEntryType.Troop,
            key: 'att',
            value: troop.att,
          } satisfies AnswerEntry as AnswerEntry,
          {
            entryId: troop.id,
            entryType: AnswerEntryType.Troop,
            key: 'of',
            value: troop.of,
          } satisfies AnswerEntry as AnswerEntry,
          {
            entryId: troop.id,
            entryType: AnswerEntryType.Troop,
            key: 'str',
            value: troop.str,
          } satisfies AnswerEntry as AnswerEntry,
          {
            entryId: troop.id,
            entryType: AnswerEntryType.Troop,
            key: 'ap',
            value: troop.ap,
          } satisfies AnswerEntry as AnswerEntry,
          {
            entryId: troop.id,
            entryType: AnswerEntryType.Troop,
            key: 'agi',
            value: troop.agi,
          } satisfies AnswerEntry as AnswerEntry,
        ];
      }),

      ...values.magics.map(
        (option) =>
          ({
            entryId: option.id,
            entryType: AnswerEntryType.Option,
            key: 'points',
            value: option.points,
          }) satisfies AnswerEntry as AnswerEntry,
      ),

      ...values.options.map(
        (option) =>
          ({
            entryId: option.id,
            entryType: AnswerEntryType.Option,
            key: 'points',
            value: option.points,
          }) satisfies AnswerEntry as AnswerEntry,
      ),

      ...values.mounts.map(
        (option) =>
          ({
            entryId: option.id,
            entryType: AnswerEntryType.Option,
            key: 'points',
            value: option.points,
          }) satisfies AnswerEntry as AnswerEntry,
      ),
    ];
  };
}
